import type { CSSProperties } from 'react';
import type { CompanyLevelType } from './model/companyLevel';

export const COMPANY_LEVEL_STYLES: Record<CompanyLevelType, CSSProperties> = {
  none: {
    background: 'var(--mantine-color-otherWhite-0)',
    border: '1px solid var(--mantine-color-primary-0)',
  },
  iron: {
    background: 'linear-gradient(90deg, #6b7280 0%, #9ca3af 50%, #d1d5db 100%)',
  },
  bronze: {
    background: 'linear-gradient(90deg, #a65f2a 0%, #cd7f32 50%, #e8a87c 100%)',
  },
  silver: {
    background: 'linear-gradient(90deg, #8b939c 0%, #c0c8d0 50%, #e5e7eb 100%)',
  },
  gold: {
    background: 'linear-gradient(90deg, #c9920a 0%, #f5c518 50%, #ffd700 100%)',
  },
  platinum: {
    background: 'linear-gradient(90deg, #c8c2b8 0%, #e8e4dc 50%, #f5f3ef 100%)',
  },
};
